import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, SearchActividadPrincipalRequest, SaveActividadPrincipalDto, ActividadPrincipal } from "../model/index";
import { SharedFunctions } from '../shared.functions';

@Injectable({
  providedIn: 'root'
})
export class ActividadPrincipalService extends CrudService<ActividadPrincipal, number, SaveActividadPrincipalDto, SearchActividadPrincipalRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'actividadprincipal', sharedFunctions);
  }
  
}
